//import 'ol/ol.css';
import { Feature } from 'ol';
import * as toastr from "toastr";
import { FeatureType, ICAMSKey, IMapInteractionConfig, IAPIResult, CloseFormEnum, TextPack } from '../Models/UtilityModels';
import { Utilities, ModalAction } from '../Utility/Utilities';
import { Photos } from '../Photos/Photos';
import * as AuthModel from '../Models/AuthModel';
import * as events from '../Bus/Bus';
import { ActivityListType, ActivityCreateModel } from '../Activity/Activity';
import { UserDefinedFields } from '../UserDefinedFields/UserDefinedFields';
import { MapLayerGroupType, MapConfigModel, INewGeometryConfig } from '../Models/MapConfigModels';
import { CAMSMap } from '../../Extensions/CAMSOLExtensions';
import { Entity_InfraCondition, infraConditionCallback } from './Entity_InfraCondition'
import { Entity_InfraHistoric } from './Entity_InfraHistoric';
import { ModalPrompts, PredefinedModalEnum } from '../Utility/ModalPrompts';

declare let moment: any; // Date helper from moment()

// LUT table 
export class InfraTypeModel { infraType: string; groupName: string; descr: string; }

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',
    placeholder_for_promptModals = '#placeholder-for-promptModals'
}

export class Entity_InfraView {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private initialised: boolean = false;
    private infraSubTypeHasChanged: boolean = false;
    private newInfraWizardState: { routeSelectedCAMSKey?: ICAMSKey, featureSelected: Feature, drawFeature?: Feature };
    private infraTypeList: Array<InfraTypeModel>;
    private photos: Photos = new Photos();
    private Entity_InfraCondition: Entity_InfraCondition = new Entity_InfraCondition();
    
    private Entity_InfraHistoric: Entity_InfraHistoric = new Entity_InfraHistoric();
    private authModel: AuthModel.IAuthModel = { policies: [] };

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor(protected map: CAMSMap, authModel: AuthModel.IAuthModel, protected mapConfigModel: MapConfigModel) {
        this.authModel = authModel;
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;
    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    public openEditPanel = (data: ICAMSKey, callback: Function): void => {
        const self = this;
        self.infraSubTypeHasChanged = false;
        Utilities.BlockUI();
        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/Infra/InfraEdit', { infraCode: data.code }, function (response, status, xhr) {
            Utilities.UnBlockUI();
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }

            // Create table
            ($('#infraEditConditionTable') as any).bootstrapTable();
            ($('#infraEditIssuesTable') as any).bootstrapTable();
            ($('#infraEditTasksTable') as any).bootstrapTable();
            if ($('#infraEditHistoricTable')[0]) ($('#infraEditHistoricTable') as any).bootstrapTable();

            Utilities.GetModal('#infraEditModal', ModalAction.Create);

            //initialise photo uploader
            self.photos.setupUploader('#infraEditModal');

            // Get UDF's and conditional fields
            UserDefinedFields.ShowHideUDFs(<string>$('#InfraType').children("option:selected").val(), $("#infraEditForm"));

            $('#infraEditModal [data-parentkey]').on('click', function () {
                const data: ICAMSKey = $(this).data("parentkey");
                if (data.featureType == FeatureType.Route) {
                    events.bus.publish(events.eventOpenRouteEditPanel(data));
                } else if (data.featureType == FeatureType.Land) {
                    events.bus.publish(events.eventOpenLandEditPanel(data));
                }
                Utilities.GetModal('#infraEditModal', ModalAction.Hide);
            });

            

            // Get form validation
            Utilities.InitFormValidation($("#infraEditForm"));
            
            $('#infraEditSubmitBtn').on('click', function (evt) {
                evt.preventDefault();
                self.sumbitInfra(data).then(s => { if (s == true) { Utilities.GetModal('#infraEditModal', ModalAction.Hide); if (callback != null) callback(true); } else if (callback != null) callback(false); });
            });

            $('#InfraGroupType').on('change', function () { self.infraTypeChanged(); });
            $('#InfraType').on('change', function () { self.infraSubTypeChanged(true); });
            $('#infraEditNewMaintBtn').on('click', function () {
                if (originalFormData !== $('#infraEditForm').serialize()) {
                    Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                        if (r == CloseFormEnum.DisregardAndProceed) self.createNewMaintOnInfra(data);
                        else if (r == CloseFormEnum.SaveAndProceed) self.sumbitInfra(data).then(s => {
                            if (s == true) self.createNewMaintOnInfra(data);
                        });
                    });
                }
                else self.createNewMaintOnInfra(data);
            });

            $('#infraEditModal [data-taskid]').on('click', function () {
                
            });

            $('#infraEditNewTaskBtn').on('click', function () {
                if (originalFormData !== $('#infraEditForm').serialize()) {
                    Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                        if (r == CloseFormEnum.DisregardAndProceed) openForm();
                        else if (r == CloseFormEnum.SaveAndProceed) self.sumbitInfra(data).then(s => {
                            if (s == true) openForm();
                        });
                    });
                }
                else openForm();

                function openForm() {
                    Utilities.GetModal('#infraEditModal', ModalAction.Hide);
                    events.bus.publish(events.eventOpenTasksCreatePanel([[data], function (r) {
                        events.bus.publish(events.eventOpenInfraEditPanel([data, callback]));
                        //if (r == true) {
                        //    events.bus.publish(events.eventOpenInfraEditPanel([data,null])); // This re-opens the edit form which refreshes the infra form
                        //}
                        //else {
                        //    Utilities.GetModal('#infraEditModal', ModalAction.Show);
                        //}
                    }]));
                }
            });

            // INFRA CONDITION
            $('#infraEditNewConditionBtn').on('click', function () {
                if (originalFormData !== $('#infraEditForm').serialize()) {
                    Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                        if (r == CloseFormEnum.DisregardAndProceed) openForm();
                        else if (r == CloseFormEnum.SaveAndProceed) self.sumbitInfra(data).then(s => {
                            if (s == true) openForm();
                        });
                    });
                }
                else openForm();
                function openForm() {
                    Utilities.GetModal('#infraEditModal', ModalAction.Hide);
                    self.Entity_InfraCondition.openConditionPanel(data, null, function (result, camsKey, newIssueFlag) {
                        if (newIssueFlag == true) self.createNewMaintOnInfra(camsKey);
                        else self.openEditPanel(camsKey, callback);
                    });
                }
            });

            // ******************************************************************************
            // InfraConditionTable Click Events

            var table: any = Utilities.GetControl('#infraEditConditionTable');
            table.bootstrapTable(); 
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {               
                if (field == "id") {
                    var ic: ICAMSKey = $element.find("[data-infraconditionref]").data("infraconditionref");
                    if (originalFormData !== $('#infraEditForm').serialize()) {
                        Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                            if (r == CloseFormEnum.DisregardAndProceed) openInfraConditionEditForm(ic);
                            else if (r == CloseFormEnum.SaveAndProceed) self.sumbitInfra(data).then(s => {
                                if (s == true) openInfraConditionEditForm(ic);
                            });
                        });
                    }
                    else openInfraConditionEditForm(ic);
                }
            });
            function openInfraConditionEditForm(ic: ICAMSKey) {
                Utilities.GetModal('#infraEditModal', ModalAction.Hide);

                self.Entity_InfraCondition.openConditionPanel(data, ic.code, function (result, camsKey, newIssueFlag) {
                    if (newIssueFlag == true) self.createNewMaintOnInfra(camsKey);
                    else self.openEditPanel(camsKey, callback);
                });
            }
            // ***************************************************************
            //Infra Issues Click event
            var table: any = Utilities.GetControl('#infraEditIssuesTable');
            table.bootstrapTable(); 
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                if (field == 'code') {
                    var data: ICAMSKey = $element.find("[data-maintref]").data("maintref");
                    if (originalFormData !== $('#infraEditForm').serialize()) {
                        Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                            if (r == CloseFormEnum.DisregardAndProceed) openMaintEditPanel();
                            else if (r == CloseFormEnum.SaveAndProceed) self.sumbitInfra(data).then(s => {
                                if (s == true) openMaintEditPanel();
                            });
                        });
                    }
                    else {
                        openMaintEditPanel();
                    }

                }
                function openMaintEditPanel() {
                    Utilities.GetModal('#infraEditModal', ModalAction.Hide);
                    events.bus.publish(events.eventOpenMaintEditPanel(data));
                }
            });

            //************************************************************* */
            //Infra Task Click event
            var table: any = Utilities.GetControl('#infraEditTasksTable');
            table.bootstrapTable();            
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {              
                if(field == 'typeDescr')
                Utilities.GetModal('#infraEditModal', ModalAction.Hide);
                var taskID = $element.data("taskid");
                var camsKey: ICAMSKey = { code: taskID, featureType: FeatureType.Task };
                events.bus.publish(events.eventOpenTasksEditPanel([camsKey, function (r) {
                    events.bus.publish(events.eventOpenInfraEditPanel([data, callback]));
                }]))

            });
            //************************************************************* */
            //Infra Historic Click event
            var table: any = Utilities.GetControl('#infraEditHistoricTable');
            table.bootstrapTable();
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {                
                if (field =='archiveDate')
                var uid = $element.data("historicid");
                if (originalFormData !== $('#infraEditForm').serialize()) {
                    Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                        if (r == CloseFormEnum.DisregardAndProceed) openForm(uid);
                        else if (r == CloseFormEnum.SaveAndProceed) self.sumbitInfra(data).then(s => {
                            if (s == true) openForm(uid);
                        });
                    });
                }
                else openForm(uid);
                function openForm(ic: ICAMSKey) {
                    Utilities.GetModal('#infraEditModal', ModalAction.Hide);

                    self.Entity_InfraHistoric.openHistoricPanel({ code: (uid as string), featureType: FeatureType.InfraHistoric }, function (result) {
                        self.openEditPanel(data, callback);
                    });
                }
            });

            
            
            //************************************************************* */
            $('#infraEditModal [data-infraconditionref]').on('click', function () {

            });
            // ACTIVITY
            getActivities(true); // Get activities when the form first loads
            $('#infraEditModal [name="showAllActivities"]').on('change', function () {
                var checked = $(this).prop('checked');
                getActivities(!checked);
            });

            function getActivities(excludeAuditActivities: Boolean) {
                events.bus.publish(events.eventGetActivities([data, excludeAuditActivities, function (d) {
                    var table = ($('#infraEditActivityTable') as any);
                    table.bootstrapTable();
                    table.bootstrapTable('load', d);

                    // Add entity click events
                    table.on('click-cell.bs.table', function (e, field, value, row, $element) {                      
                        if (field == 'uid') {
                            var acID: number = $element.find("[data-activityid]").data("activityid");
                            if (originalFormData !== $('#infraEditForm').serialize()) {
                                Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                                    if (r == CloseFormEnum.DisregardAndProceed) openContact();
                                    else if (r == CloseFormEnum.SaveAndProceed) self.sumbitInfra(data).then(s => {
                                        if (s == true) openContact();
                                    });
                                });
                            }
                            else openContact();
                        }
                        function openContact() {
                            Utilities.GetModal('#infraEditModal', ModalAction.Hide);
                            events.bus.publish(events.eventOpenActivityDetailsPanel([acID, function (r) {
                                if (r == true) {
                                    events.bus.publish(events.eventOpenInfraEditPanel([data, callback])); // This re-opens the edit form which refreshes the Maint form
                                }
                                else {
                                    Utilities.GetModal('#infraEditModal', ModalAction.Show);
                                }
                            }]));
                        }
                    });
                    
                }]));
            }

            $('#infraEditNewActivityBtn').on('click', function () {
                if (originalFormData !== $('#infraEditForm').serialize()) {
                    Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                        if (r == CloseFormEnum.DisregardAndProceed) openForm();
                        else if (r == CloseFormEnum.SaveAndProceed) self.sumbitInfra(data).then(s => {
                            if (s == true) openForm();
                        });
                    });
                }
                else openForm();

                function openForm() {
                    Utilities.GetModal('#infraEditModal', ModalAction.Hide);
                    var activityData: ActivityCreateModel = { ID: data.code, activityListType: ActivityListType.InfraActivity };
                    events.bus.publish(events.eventOpenActivityCreatePanel([activityData, function (r) {
                        if (r == true) {
                            events.bus.publish(events.eventOpenInfraEditPanel([data, callback])); // This re-opens the edit form which refreshes the Land form
                        }
                        else {
                            Utilities.GetModal('#infraEditModal', ModalAction.Show);
                        }
                    }]));
                }
            });

            // HISTORIC
            $('#infraEditModal [data-historicid]').on('click', function () {
               

            });

            //these fields trigger calculations when changed
            $('#ReplacementCost').on('change', function () { self.calculateDepreciation(); self.calculateReplacementDate(); });
            $('#LifeExpectancy').on('change', function () { self.calculateDepreciation(); self.calculateReplacementDate(); });
            $('#DateInst').on('change', function () { self.calculateDepreciation(); self.calculateReplacementDate(); });

            $('#infraEditCancelBtn').on('click', function (evt) {
                if (originalFormData !== $('#infraEditForm').serialize()) {
                    Utilities.CloseFormWithPrompt().then(r => {
                        if (r == true) {
                            Utilities.GetModal('#infraEditModal', ModalAction.Hide);
                            if (callback != null) callback(true);
                        }
                    });
                }
                else {
                    Utilities.GetModal('#infraEditModal', ModalAction.Hide);
                    if (callback != null) callback(false);
                }
            });

            $('#infraEditCloseBtn').on('click', function (evt) {
                if (originalFormData !== $('#infraEditForm').serialize()) {
                    Utilities.CloseFormWithPrompt().then(r => {
                        if (r == true) {
                            Utilities.GetModal('#infraEditModal', ModalAction.Hide);
                            if (callback != null) callback(true);
                        }
                    });
                }
                else {
                    Utilities.GetModal('#infraEditModal', ModalAction.Hide);
                    if (callback != null) callback(false);
                }
            });

            $('#infraEditDeleteBtn').on('click', function (evt) {
                self.deleteEntity(data, callback);
            });

            // Load the infra types if required
            if (self.infraTypeList == null) self.loadInfraLUTs();

            // Save the original state of the edit form
            var originalFormData = $('#infraEditForm').serialize();

        });
    }

    public openCreatePanel = (data: ICAMSKey, callback: Function): void => {
        const self = this;
        Utilities.BlockUI();
        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/Infra/InfraCreate', data, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            Utilities.GetModal('#infraCreateModal', ModalAction.Create);

            $('#InfraGroupType').on('change', function () { self.infraTypeChanged(); });
            $('#InfraType').on('change', function () { self.infraSubTypeChanged(false); });

            //these fields trigger calculations when changed
            $('#ReplacementCost').on('change', function () { self.calculateDepreciation(); self.calculateReplacementDate(); });
            $('#LifeExpectancy').on('change', function () { self.calculateDepreciation(); self.calculateReplacementDate(); });
            $('#DateInst').on('change', function () { self.calculateDepreciation(); self.calculateReplacementDate(); });

            // Get form validation
            Utilities.InitFormValidation($("#infraConditionForm"));

            //initialise photo uploader
            self.photos.setupUploader('#infraCreateModal');

            $('#infraCreateSubmitBtn').on('click', function (evt) {
                evt.preventDefault();
                submit(false);
            });

            $('#infraCreateSubmitAndEditBtn').on('click', function (evt) {
                evt.preventDefault();
                submit(true);
            });

            function submit(showEditForm: Boolean) {
                // Validate
                if (Utilities.CheckFormValidation($('#infraCreateForm')) == false) return;

                Utilities.BlockUI($("#infraCreateModal .modal-content"));
                let formData = new FormData(<any>$('#infraCreateForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: window.G_SITEFOLDERNAME + '/Infra/CreateInfra',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                Utilities.GetModal('#infraCreateModal', ModalAction.Hide);
                                events.bus.publish(events.eventClearEditLayer());
                                events.bus.publish(events.eventRefreshMapLayer(FeatureType.Infra));
                                events.bus.publish(events.eventEntityUpdated(data));
                                events.bus.publish(events.eventNewInfraWizardStart([data, self.newInfraWizardState?.featureSelected, callback]));
                                if (showEditForm == true) { self.openEditPanel({ code: result.data.infraCode, featureType: FeatureType.Infra }, callback) }
                                else if (callback != null) callback(true);

                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                            }
                            else {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                                if (callback != null) callback(false);
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI($("#infraCreateModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            }

            $('#infraCreateCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#infraCreateModal', ModalAction.Hide);
                events.bus.publish(events.eventNewMapGeometryRestart(null));
                if (callback != null) callback(false);
            });

            $('#infraCreateCloseBtn').on('click', function (evt) {
                Utilities.GetModal('#infraCreateModal', ModalAction.Hide);
                events.bus.publish(events.eventNewMapGeometryRestart(null));
                if (callback != null) callback(false);
            });

            // Load the infra types if required
            if (self.infraTypeList == null) self.loadInfraLUTs();
        });
    }

    public openConditionPanel = (data: ICAMSKey, infraConditionCode: string, callback: infraConditionCallback): void => {
        this.Entity_InfraCondition.openConditionPanel(data, infraConditionCode, callback);
    }

    // ----------------------------------------------------------- //
    // DELETE
    public deleteEntity = (data: ICAMSKey, callback: Function): void => {
        const self = this;
        var promptType = PredefinedModalEnum.Delete;
        if (self.authModel.policies.indexOf(AuthModel.CAMSMap_CanDeleteInfraHistoric) > 0) promptType = PredefinedModalEnum.InfraDeleteAndArchive;
      
        ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: promptType }).then(r => {
            if (r.yes == true) {
                doDelete(false);
            }
            else if (r.extraBtn == true) {
                doDelete(true);
            }
            else {
            }
        }).catch(e => { });

        function doDelete(archive: boolean) {
            Utilities.BlockUI();
            $.post(window.G_SITEFOLDERNAME + '/Infra/DeleteInfra', { camsKey: data, makeHistoric: archive },
                function (result: IAPIResult) {
                    Utilities.UnBlockUI();
                    try {
                        if (result.success == true) {
                            events.bus.publish(events.eventRefreshMapLayer(FeatureType.Infra));
                            if (archive == true) events.bus.publish(events.eventRefreshMapLayer(FeatureType.InfraHistoric));
                            events.bus.publish(events.eventClearAllHighlights());
                            events.bus.publish(events.eventResetAllPanels());
                            events.bus.publish(events.eventRemoveAllMapInteractions());
                            events.bus.publish(events.eventResetAllButtons(true));
                            Utilities.GetModal('#infraEditModal', ModalAction.Hide);
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                            if (callback != null) callback(true);
                        }
                        else {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                            if (callback != null) callback(false);
                        }
                    }
                    catch (err) {
                        console.log(err);
                        alert(err);
                    }
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }

    // ----------------------------------------------------------- //
    // MISC
    private infraTypeChanged = (): void => {
        // Remove all options
        $('#InfraType').find('option').remove().end();
        // Populate the list based on the selected group name
        let infraGroupTypeStr = $('#InfraGroupType').children("option:selected").val(); // Get the selected option
        this.infraTypeList.forEach(i => {
            if (i.groupName == infraGroupTypeStr) {
                $('#InfraType').append($("<option></option>").attr("value", i.infraType).text(i.descr));
            }
        });

        $('#InfraType').change();//fire the event because it doesn't happen automatically
    }

    private infraSubTypeChanged = (showWarning: boolean): void => {
        const self = this;
        self.infraSubTypeHasChanged = true;

        let doDefaults: Function = function () {
            let infraType = <string>$('#InfraType').children("option:selected").val(); // Get the selected option

            // Set the conditional UDFs
            UserDefinedFields.ShowHideUDFs(infraType, $("#infraEditForm"));

            // Get the default values from the server
            self.setInfraDefaultValues(infraType);
        }

        if (!showWarning) {//don't want to show popup
            doDefaults();
        }
        else if ($('#ReplacementCost').val() == '' && $('#LifeExpectancy').val() == '') {//no need to show popup because fields are blank anyway
            doDefaults();
        }
        else { //show a dialog

            ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.InfraOverwriteReplacementCost }).then(r => {
                if (r.yes == true) {
                    doDefaults();
                }
                else {
                }
            }).catch(e => { });
        }
    }

    private loadInfraLUTs = (): void => {
        const self = this;
        $.ajax({
            url: window.G_SITEFOLDERNAME + '/LUT/GetInfraTypeLUT',
            success: function (data) {
                self.infraTypeList = data;
            },
            error: function (e) {
                console.log("Error getting GetInfraTypeLUT", e);
            }
        });
    }

    private setInfraDefaultValues = (infraType: string): void => {
        const self = this;
        $.ajax({
            url: window.G_SITEFOLDERNAME + '/LUT/GetInfraDefaultValues/' + infraType,
            success: function (data) {
                if (data != null && data != undefined && data.result != null && data.result != undefined) {
                    //set the defaulted fields
                    $('#ReplacementCost').val(data.Result.ReplacementCost);
                    $('#LifeExpectancy').val(data.Result.LifeExpectancy);

                }
                //fill in the calculated fields
                self.calculateReplacementDate();
                self.calculateDepreciation();
            },
            error: function (e) {
                console.log("Error getting setInfraDefaultValues", e);
            }
        });
    }

    private calculateReplacementDate = (): void => {
        //get the form values
        let lifeExpString = <string>$('#LifeExpectancy').val();
        let instDateString = <string>$('#DateInst').val();

        //check there are values to work on
        if (lifeExpString != '' && instDateString != '') {
            //convert from strings
            let lifeExp = parseFloat(lifeExpString);
            let instDate = new Date(instDateString);
            if (moment(instDate).isValid() && lifeExp >= 0) {
                //calculate replacement date
                instDate.setFullYear(instDate.getFullYear() + lifeExp);

                //set the form value
                $('#ReplacementDate').val(moment(instDate).format("DD-MMM-YYYY"));
            }

        }
    }

    private calculateDepreciation = (): void => {
        //get the form values
        let lifeExpString = <string>$('#LifeExpectancy').val();
        let instDateString = <string>$('#DateInst').val();
        let repCostString = <string>$('#ReplacementCost').val();

        //check there are values to work on
        if (lifeExpString != '' && instDateString != '' && repCostString != '') {
            //convert from strings
            let lifeExp = parseFloat(lifeExpString);
            let instYear = parseInt(instDateString.split('/', 3)[2]);
            let repCost = parseFloat(repCostString);

            //avoid divide-by-zero!
            if (lifeExp > 0) {
                //calculate the deprectiaion
                let annualcost = repCost / lifeExp;
                let age = (new Date()).getFullYear() - instYear;
                let depreciation = (repCost - (age * annualcost)).toFixed(2);

                //set the form value
                $('#DeprecationValue').val(depreciation.toString());
            }
        }
    }

    private sumbitInfra = (data: ICAMSKey): Promise<Boolean> => {
        var self = this;

        return new Promise<boolean>(function (resolve, reject) {

            // Validate
            if (Utilities.CheckFormValidation($('#infraEditForm')) == false) return;

            // Check if InfraHistoric is enabled
            if (self.authModel.policies.indexOf(AuthModel.CAMSMap_CanSeeInfraHistoric) > 0 && self.infraSubTypeHasChanged == true) {
                ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.InfraMakeHistoric }).then(r => {
                    if (r.yes == true) {
                        doSubmit(true);
                    }
                    else {
                        doSubmit(false);
                    }
                }).catch(e => { });
            }
            else { return doSubmit(false); }

            function doSubmit(makeHistoric) {
                Utilities.BlockUI($("#infraEditModal .modal-content"));

                let formData = new FormData(<any>$('#infraEditForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Infra/UpdateInfra?makeHistoric='+makeHistoric,
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_EditComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });

                                UserDefinedFields.SaveUDFFieldsAtServer($('#infraEditForm'), '/Infra/UpdateInfraUserFields');
                                events.bus.publish(events.eventRefreshMapLayer(FeatureType.Infra));
                                events.bus.publish(events.eventEntityUpdated(data));
                                resolve(true);
                            }
                            else {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_EditFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });

                                resolve(false);
                            }
                        }
                        catch (err) {
                            console.log(err);
                            resolve(false);
                        }
                        finally {
                            Utilities.UnBlockUI($("#infraEditModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            }
        });
    }

    // ----------------------------------------------------------- //
    // CREATE new linked records
    private createNewMaintOnInfra = (data: ICAMSKey): void => {
        events.bus.publish(events.eventResetAllPanels());
        events.bus.publish(events.eventRemoveAllMapInteractions());
        events.bus.publish(events.eventZoomToLocationAndThenHighlightFeature([data, true, null]));
        events.bus.publish(events.eventGetSelectedFeatures(function (features) {
            Utilities.GetModal('#infraEditModal', ModalAction.Hide);
            events.bus.publish(events.eventNewMaintWizardStart([data, features[0], null]));
        }));
    }
}